/**
 * /time-clock — the employee check-in screen on a device signed in to the back office (a
 * tablet at the door). The same screens as the Time Clock app (apps/timeclock: ClockPage,
 * HistoryPage), on the back office's session; the punches are time_clock_entries rows, the
 * rows Payroll pays.
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { getBranchAuthHeaders } from '@/utils/branchApi';
import { TimeclockProvider } from '@/apps/timeclock/context/TimeclockContext';
import ClockPage from '@/apps/timeclock/pages/ClockPage';
import HistoryPage from '@/apps/timeclock/pages/HistoryPage';

export default function EmployeeClockPage({ authHeaders = getBranchAuthHeaders }) {
  const [view, setView] = useState('clock');
  const signedIn = !!localStorage.getItem('backoffice_token');
  if (authHeaders === getBranchAuthHeaders && !signedIn) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 p-6">
        <div className="max-w-sm text-center space-y-4">
          <Clock className="w-10 h-10 mx-auto text-emerald-300" />
          <h1 className="text-xl font-semibold text-white">Employee Time Clock</h1>
          <p className="text-slate-400">This screen runs on a device signed in to the restaurant. Sign in to the back office first, then open the time clock.</p>
          <Link to="/owner/login" className="inline-block rounded-xl bg-emerald-500 px-5 py-3 font-medium text-white hover:bg-emerald-400">Sign in</Link>
        </div>
      </div>
    );
  }
  return (
    <TimeclockProvider authHeaders={authHeaders} auth={authHeaders === getBranchAuthHeaders ? 'backoffice' : 'account'}>
      {view === 'clock'
        ? <ClockPage title="Employee Time Clock" onHistory={() => setView('history')} />
        : <HistoryPage onBack={() => setView('clock')} />}
    </TimeclockProvider>
  );
}
